(() => {
    const scrollToContainer = (container) => {
        if (!container || !window.lenis) return;

        window.lenis.scrollTo(container, {
            offset: -headerHeight
        });
    };

    const paginationTemplate = (pages, currentIndex) =>
        Array.from({ length: pages }, (_, i) => `<li data-index="${i}" class="${i === currentIndex ? 'active' : ''}"><a href="${location.pathname}${i ? `?pg=${i + 1}` : ''}">${i + 1}</a></li>`).join('');

    const getElementsByNameMap = (form) => {
        const map = {};
        for (const el of form.elements) {
            if (el.name) {
                const baseName = el.name.replace(/\[\]$/, '');

                if (!map[el.name]) map[el.name] = [];
                map[el.name].push(el);

                if (baseName !== el.name) {
                    if (!map[baseName]) map[baseName] = [];
                    map[baseName].push(el);
                }
            }
        }
        return map;
    };

    const initializedListings = new WeakSet();

    const initListing = (listing, index) => {
        if (initializedListings.has(listing)) return;
        initializedListings.add(listing);

        const elements = {
            filter: listing.querySelector(".js-listing-filter"),
            container: listing.querySelector(".js-listing-content"),
            results: listing.querySelectorAll(".js-listing-results")
        };

        const paginationEl = listing.querySelector(".js-listing-pagination");
        const pagination = paginationEl ? {
            el: paginationEl,
            arrows: paginationEl.querySelectorAll("button"),
            list: paginationEl.querySelector("ul"),
            currentIndex: 0,
            _prevActive: null,
            get currentPage() {
                return this.list && this.list.children && this.list.children[this.currentIndex];
            }
        } : null;

        const object = { elements, pagination, controller: null, req: null };
        const sessionKey = "listing_state_" + window.location.pathname + "_" + index;

        const updatePagination = () => {
            if (!pagination || !pagination.el) return;

            const listCount = pagination.list.childElementCount || 0;
            const idx = pagination.currentIndex;
            const leftBtn = pagination.arrows && pagination.arrows[0];
            const rightBtn = pagination.arrows && pagination.arrows[1];
            const prev = pagination._prevActive;
            const cur = pagination.currentPage;

            leftBtn && leftBtn.toggleAttribute("disabled", idx === 0 || listCount === 0);
            rightBtn && rightBtn.toggleAttribute("disabled", idx === listCount - 1 || listCount === 0);

            prev && prev.classList.remove("active");
            cur && cur.classList.add("active");

            pagination._prevActive = cur;
        };

        function loadListing(resetPage = true, isInit = false) {
            if (!elements || !elements.container) return;

            elements.container.parentElement.classList.add("loading");

            if (!isInit)
                scrollToContainer(listing);

            if (resetPage && pagination)
                pagination.currentIndex = 0;

            object.controller && object.controller.abort();
            object.controller = new AbortController();

            const signal = object.controller.signal;
            const req = elements.filter ? new FormData(elements.filter) : new FormData();

            if (pagination) {
                req.set("page_from", String(pagination.currentIndex));
            }

            const baseUrl = typeof site_url !== 'undefined' ? site_url : '/';

            fetch(baseUrl + "ajax/functions.php", {
                method: "POST",
                body: req,
                signal
            })
                .then(res => {
                    if (!res.ok) throw new Error("Network error: " + res.status);
                    return res.json();
                })
                .then(data => {
                    elements.container.dataset.results = data.results;
                    elements.results.forEach(el => el.dataset.results = data.results);
                    elements.container.innerHTML = data.html;

                    elements.container.dispatchEvent(new CustomEvent("listing:updated", {
                        bubbles: true,
                        detail: data
                    }));

                    if ((resetPage || isInit) && pagination && pagination.el) {
                        if (data.count > 1) {
                            pagination.el.classList.remove("d-none");
                            pagination.list.innerHTML = paginationTemplate(data.count, pagination.currentIndex);
                        } else {
                            pagination.el.classList.add("d-none");
                            pagination.list.innerHTML = "";
                        }

                        pagination.currentIndex = Math.min(pagination.currentIndex, (pagination.list.childElementCount - 1) || 0);
                        updatePagination();
                    }
                })
                .catch(err => {
                    err.name !== "AbortError" && console.error("Listing Fetch Error:", err);
                })
                .finally(() => {
                    !signal.aborted && elements.container.parentElement.classList.remove("loading");
                });
        }

        const saveState = () => {
            if (!elements.filter) return;
            const formData = new FormData(elements.filter);
            const state = {
                filters: {},
                page: pagination ? pagination.currentIndex : 0
            };

            const inputMap = getElementsByNameMap(elements.filter);

            for (const [key, value] of formData.entries()) {
                const inputs = inputMap[key] || [];
                let isDrivenByHidden = false;
                let isDrivenByVisible = false;

                for (const input of inputs) {
                    let isActive = false;

                    if (input.type === 'checkbox' || input.type === 'radio')
                        isActive = (input.checked && input.value === value);
                    else
                        isActive = (input.value === value);

                    if (isActive) {
                        if (input.type === 'hidden') isDrivenByHidden = true;
                        else isDrivenByVisible = true;
                    }
                }

                if (isDrivenByHidden && !isDrivenByVisible) continue;

                if (!state.filters[key]) state.filters[key] = [];
                state.filters[key].push(value);
            }

            sessionStorage.setItem(sessionKey, JSON.stringify(state));
        };

        const restoreState = () => {
            const saved = sessionStorage.getItem(sessionKey);
            if (!saved) return false;

            try {
                const state = JSON.parse(saved);
                let restoredSomething = false;

                if (elements.filter && state.filters) {
                    elements.filter.reset();
                    const inputMap = getElementsByNameMap(elements.filter);

                    for (const key in state.filters) {
                        const values = state.filters[key];
                        const inputs = inputMap[key] || [];

                        inputs.forEach((input, index) => {
                            if (input.type === 'checkbox' || input.type === 'radio') {
                                if (values.includes(input.value) || values.includes(input.dataset.param)) {
                                    input.checked = true;
                                    restoredSomething = true;

                                    const dropdown = input.closest(".js-dropdown");
                                    if (dropdown && input.dataset.label)
                                        dropdown.firstElementChild.textContent = input.dataset.label;
                                }
                            } else {
                                if (values[index] !== undefined) {
                                    input.value = values[index];
                                    restoredSomething = true;
                                } else if (values.length > 0 && inputs.length === 1) {
                                    input.value = values[0];
                                    restoredSomething = true;
                                }
                            }
                        });
                    }
                }

                if (pagination && state.page !== undefined) {
                    pagination.currentIndex = Number(state.page);
                    restoredSomething = true;
                }

                return restoredSomething;
            } catch (e) {
                console.error("Failed to parse session storage", e);
                return false;
            }
        };

        if (elements.filter) {
            const params = new URLSearchParams(location.search);
            let foundUrlParam = false;
            let hasVisibleParam = false;
            const inputMap = getElementsByNameMap(elements.filter);

            for (const [name, rawValue] of params.entries()) {
                if (!rawValue) continue;

                const values = rawValue.split(',').map(s => s.trim()).filter(Boolean);
                if (!values.length) continue;

                const baseName = name.replace(/\[\]$/, '');
                const inputs = inputMap[baseName] || [];

                inputs.forEach((input, index) => {
                    const param = input.dataset.param;
                    let isMatch = false;

                    if (input.type === 'checkbox' || input.type === 'radio') {
                        if ((param && values.includes(param)) || values.includes(input.value)) {
                            input.checked = true;
                            isMatch = true;
                        }
                    } else {
                        if (inputs.length === 1) {
                            input.value = rawValue;
                            isMatch = true;
                        } else if (values[index] !== undefined) {
                            input.value = values[index];
                            isMatch = true;
                        }
                    }

                    if (isMatch) {
                        foundUrlParam = true;
                        input.type !== 'hidden' && (hasVisibleParam = true);
                    }
                });
            }

            if (!foundUrlParam) {
                restoreState();
            } else {
                sessionStorage.removeItem(sessionKey);
                saveState();
                hasVisibleParam && scrollToContainer(listing);
            }

            const debouncedLoad = debounce(() => {
                saveState();
                loadListing(true);
            }, 350);

            elements.filter.addEventListener("input", () => {
                if (pagination) pagination.currentIndex = 0;
                debouncedLoad();
            });

            elements.filter.addEventListener("reset", () => {
                sessionStorage.removeItem(sessionKey);

                const url = new URL(window.location.href);
                url.search = '';
                window.history.replaceState({}, '', url);

                setTimeout(() => loadListing(true), 0);
            });
        }

        if (pagination && pagination.el) {
            pagination.el.addEventListener("click", (e) => {
                const target = e.target;
                if (!target) return;

                if (target.nodeName === "BUTTON") {
                    if (target === pagination.arrows[0]) {
                        pagination.currentIndex = Math.max(0, pagination.currentIndex - 1);
                    } else {
                        pagination.currentIndex = Math.min((pagination.list.childElementCount || 1) - 1, pagination.currentIndex + 1);
                    }
                } else if (target.closest("li")) {
                    e.preventDefault();
                    const idx = Number(target.closest("li").dataset.index);
                    if (!Number.isNaN(idx)) pagination.currentIndex = idx;
                } else {
                    return;
                }

                updatePagination();
                saveState();
                loadListing(false);
            });
        }

        const urlPage = Number(new URLSearchParams(location.search).get("pg"));
        if (pagination && urlPage > 1) pagination.currentIndex = urlPage - 1;

        loadListing(false, true);
    };

    const scanListings = () => {
        document.querySelectorAll(".js-listing").forEach((listing, index) => {
            initListing(listing, index);
        });
    };

    scanListings();

    let observerTimeout;
    const domObserver = new MutationObserver(mutations => {
        const hasNewContent = mutations.some(mutation =>
            Array.from(mutation.addedNodes).some(node =>
                node.nodeType === 1 && (node.matches(".js-listing") || node.querySelector(".js-listing"))
            )
        );

        if (hasNewContent) {
            clearTimeout(observerTimeout);
            observerTimeout = setTimeout(scanListings, 50);
        }
    });

    domObserver.observe(document.body, { childList: true, subtree: true });
})();